<template>
  <div>
    <h2 class="text-center">API Keys</h2>
    <p class="text-center">
      총 <strong>{{ apiKeys.length }}</strong>개 활성 API 키
    </p>

    <div class="row justify-content-md-center">
      <div class="col-md-auto btn-group" role="group" style="padding-bottom: 20px">
        <button type="button" class="btn btn-secondary" @click="loadApiKeys">
          새로고침
        </button>
      </div>
    </div>

    <div v-if="apiKeys.length === 0" class="text-center text-muted py-4">
      API 키가 없습니다
    </div>

    <div v-for="group in keysByOwner" :key="group.owner">
      <b-card no-body class="mb-2">
        <b-card-header
          class="d-flex justify-content-between align-items-center"
          style="cursor: pointer;"
          @click="toggleOwner(group.owner)"
        >
          <span>
            <strong>{{ group.owner }}</strong>
            <b-badge variant="secondary" class="ml-2">{{ group.keys.length }}</b-badge>
          </span>
          <i
            class="fa"
            :class="openOwners[group.owner] ? 'fa-chevron-up' : 'fa-chevron-down'"
          />
        </b-card-header>

        <b-collapse :visible="openOwners[group.owner] || false">
          <div class="table-responsive-wrapper">
            <table class="table table-hover table-sm mb-0">
              <thead class="remove-top-border">
                <tr>
                  <th scope="col">Key ID</th>
                  <th scope="col">Key Prefix</th>
                  <th scope="col">생성 시간</th>
                  <th scope="col">마지막 요청 시간</th>
                  <th scope="col">총 요청 건수</th>
                  <th class="text-center" scope="col">삭제</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="key in group.keys" :key="key.key_id">
                  <td><code>{{ key.key_id }}</code></td>
                  <td><code>{{ key.key_prefix }}...</code></td>
                  <td>{{ formatDate(key.created_at) }}</td>
                  <td>{{ key.last_used_at ? formatDate(key.last_used_at) : '없음' }}</td>
                  <td>{{ key.total_requests || 0 }}</td>
                  <td class="text-center">
                    <i
                      class="fa fa-remove delete-icon"
                      @click="revokeApiKey(key)"
                      title="API 키 삭제"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-collapse>
      </b-card>
    </div>
  </div>
</template>

<script>
import toastrs from "@/mixins/toastrs";
import axios from "@/libs/axios";

export default {
  name: "ApiKeyManagement",
  mixins: [toastrs],
  data() {
    return {
      apiKeys: [],
      openOwners: {}
    };
  },
  computed: {
    keysByOwner: function() {
      var groups = {};
      for (var i = 0; i < this.apiKeys.length; i++) {
        var key = this.apiKeys[i];
        var owner = key.owner_name || 'Unknown';
        if (!groups[owner]) {
          groups[owner] = { owner: owner, keys: [] };
        }
        groups[owner].keys.push(key);
      }
      return Object.keys(groups).sort().map(function(k) {
        return groups[k];
      });
    }
  },
  methods: {
    toggleOwner: function(owner) {
      this.$set(this.openOwners, owner, !this.openOwners[owner]);
    },
    loadApiKeys: function() {
      axios.get('/api/keys/admin/all')
        .then(function(response) {
          if (response.data.success) {
            this.apiKeys = response.data.keys;
            // Initialize openOwners for new owners
            var owners = {};
            for (var i = 0; i < this.apiKeys.length; i++) {
              var owner = this.apiKeys[i].owner_name || 'Unknown';
              if (this.openOwners[owner] === undefined) {
                owners[owner] = true;
              }
            }
            for (var k in owners) {
              this.$set(this.openOwners, k, true);
            }
          }
        }.bind(this))
        .catch(function(error) {
          console.error('Failed to load API keys:', error);
        });
    },
    revokeApiKey: function(key) {
      var yes = confirm(
        "Are you sure you want to revoke API key " +
          key.key_id +
          " (Owner: " + (key.owner_name || 'Unknown') + ")?" +
          " This action cannot be undone."
      );
      if (!yes) return;

      var self = this;
      axios.delete('/api/keys/admin/' + key.key_id)
        .then(function(response) {
          if (response.data.success) {
            self.$toastr.info("API key revoked successfully", "Revoke API Key");
            self.loadApiKeys();
          }
        })
        .catch(function(error) {
          var msg = (error.response && error.response.data && error.response.data.message) || 'Revoke failed';
          self.axiosReqestError("Revoke API Key", msg);
        });
    },
    formatDate: function(dateString) {
      if (!dateString) return 'N/A';
      var date = new Date(dateString);
      return date.toLocaleDateString('ko-KR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      });
    }
  },
  created: function() {
    this.loadApiKeys();
  }
};
</script>

<style scoped>
.remove-top-border {
  border: none !important;
}
.table th {
  white-space: nowrap;
}
.table td {
  white-space: nowrap;
}
.table-responsive-wrapper {
  overflow-x: auto;
  width: 100%;
}
.fa {
  margin: 0;
  padding: 2px;
  font-size: 16px;
  cursor: pointer;
}
.delete-icon:hover {
  color: red;
}
</style>
